import React from "react";
import "./DoughnutLinearChart.css";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import LinearChart from "../LinearChart/LinearChart";
import { IMG_URL} from "../../config";
import ww from "../../images/white-lock.svg"
ChartJS.register(ArcElement, Tooltip);

function DoughnutLinearChart({value = 0,gauge_color,gauge_title,label = "Trait", subLabel = "", description = "",tierName = "",TriatData,bg_color_1,bg_color_2,showlock,UnLockModal,setUnLockModal}) {

  console.log(showlock,'showlock');
  // const tierColorMap = {
  //   Apex: "#c9a020",
  //   Force: "#7a9cc0",
  //   Balanced: "#70b070",
  //   Flicker: "#d0a020",
  //   Whisper: "#8a7aaa",
  // };

  // const finalBaseColor = tierColorMap[tierName] || baseColor;


  const baseColor = bg_color_1 || gauge_color ||'#000000';

  const lightenHSL = (hex, percent) => {
    let r = parseInt(hex?.slice(1, 3), 16) / 255;
    let g = parseInt(hex?.slice(3, 5), 16) / 255;
    let b = parseInt(hex?.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
        default:
          break;
      }

      h /= 6;
    } else {
      h = s = 0;
    }

    l = Math.min(1, l + percent / 100);

    return `hsl(${Math.round(h * 360)}, ${Math.round(s * 100)}%, ${Math.round(l * 100)}%)`;
  };

  const lightenAmount = value * 0.4;
  const dynamicColor = lightenHSL(baseColor, lightenAmount);

  const data = {
    datasets: [
      {
        data: [value, 100 - value],
        borderWidth: 0,
        cutout: "75%",
        backgroundColor: (context) => {
          const { chart } = context;
          const { ctx, chartArea } = chart;

          if (!chartArea) return baseColor;

          const centerX = (chartArea.left + chartArea.right) / 2;
          const centerY = (chartArea.top + chartArea.bottom) / 2;

          const lightenAmount = value * 0.4;
          const lightColor = lightenHSL(baseColor, lightenAmount);

          const gradient = ctx.createConicGradient(
            -0.5 * Math.PI, // start from top
            centerX,
            centerY,
          );

          // dark at 0%
          gradient.addColorStop(0, baseColor);

          // light exactly at value%
          // gradient.addColorStop(value / 100, lightColor);

          // keep light until arc ends
          // gradient.addColorStop(1, lightColor);

          return context.dataIndex === 0 ? gradient : bg_color_2;
        },
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  const handleSub = () => {
    
    setUnLockModal(true);
  };

  return (
    <div className="cir-lean-main">
      <div className={`cir-lean-cont `}>
        {/* <h6>Your 6 Trait degrees</h6> */}

        <div className={`cir-lean-chart-box ${showlock ? 'show_lock' : ''}`} 

                               onClick={
                                showlock
                                  ? () => handleSub()
                                  : undefined
                              }>

          <div className="circle-wrapper">

            <Doughnut data={data} options={options} />
            <div className="circle-text" style={{"--text-color":gauge_color}}  >{value}%</div>
            <div className="circle-text2" style={{"--text-color":gauge_color}}  >{gauge_title}</div>
            <span><img src={ww} alt="" /></span>

          </div>

          <div className="bar-graph-div">
            <LinearChart
              value={value}
              label={label}
              subLabel={subLabel}
              description={description}
              gradientColors={[`${bg_color_1}`,`${bg_color_1}`]}
              trackColor={bg_color_2}
              iconimage={`${IMG_URL}/d0/${TriatData?.trait_icon}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DoughnutLinearChart;
